/* ab2026-24 · Avatar Barefoot en Kids para todo el tráfico (test A/B). Lo carga snippets/ab2026-24-avatar-kids.liquid.
   Enlaces a Kids: las colecciones del snippet y las fichas kids-standard, con el criterio de assets/lj-avatar-visita.js.
   Cierre: borrar este fichero. */
(function () {
  'use strict';
  if (window.__ab2026_24Init) return;
  window.__ab2026_24Init = true;

  var cfg = window.theme && window.theme.ab2026_24;
  if (!cfg) return;
  var CLAVE = 'ab2026-24';
  var VISITA = 'ab2026-24-visita';
  var FICHA = { 'kids-standard': 'avatar-barefoot' };
  var FICHA_PROPIA = 'product-form.js-product';
  var estado = null;   /* null = sin decidir · true = variante · false = control */
  var decisor = null;

  function leer(clave) { try { return sessionStorage.getItem(clave); } catch (e) { return null; } }

  /* Fuera del test: quien entró por una vista barefoot (anuncios avatar, lj_avatar), que ya la ve siempre,
     y quien viene de un anuncio de Halloween (hw2026_ad), que ve Halloween distinto en cada plantilla. */
  function deAnuncio() {
    if (leer('lj_avatar') || leer('hw2026_ad') === '1') return true;
    return cfg.pagina.indexOf('avatar-barefoot') !== -1 && leer(VISITA) !== '1';
  }

  function vista(a) {
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { return null; }
    if (url.origin !== location.origin || url.searchParams.has('view')) return null;
    var ruta = url.pathname.replace(/\/$/, '');
    if (ruta.indexOf('/products/') !== -1) {
      var tarjeta = a.closest('[data-lj-tpl]');
      var tpl = tarjeta ? tarjeta.getAttribute('data-lj-tpl') : (cfg.producto && a.closest(FICHA_PROPIA) ? cfg.producto : null);
      return FICHA[tpl] ? [url, FICHA[tpl]] : null;
    }
    var v = cfg.colecciones[ruta];
    return v ? [url, v] : null;
  }

  function decidir() {
    if (typeof decisor !== 'function') return;
    var v;
    try { v = decisor() === true; } catch (e) { return; }
    estado = v;
    try { localStorage.setItem(CLAVE, String(v)); } catch (e) {}
  }

  /* En pointerdown solo se reescribe lo ya decidido: un toque para hacer scroll no es entrar en Kids. */
  function alTocar(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || deAnuncio()) return;
    var r = vista(a);
    if (!r) return;
    /* Filtros y paginación de la página de llegada: no se cambia de versión a mitad de colección. */
    var enBarefoot = cfg.pagina.indexOf('avatar-barefoot') !== -1;
    if (!enBarefoot && r[0].pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '')) return;
    if (e.type !== 'pointerdown') decidir();
    if (estado !== true) return;
    r[0].searchParams.set('view', r[1]);
    a.setAttribute('href', r[0].pathname + r[0].search + r[0].hash);
    try { sessionStorage.setItem(VISITA, '1'); } catch (e) {}
  }
  ['pointerdown', 'click', 'auxclick'].forEach(function (t) {
    document.addEventListener(t, alTocar, true);
  });

  window.__ab2026_24 = {
    fijar: function (variante) { estado = variante === true; },
    decisor: function (fn) { decisor = fn; },
    estado: function () { return estado; }
  };
})();
